module.exports = __webpack_public_path__ + "img/icon_alphabetic.e18cb7d7.svg";